<template>
  <div id="alternate-form" class="container">

    <template v-if="brokenPage">
      <h3>Sorry, we have encountered an error.</h3>
      <p>It appears that the url you have used is incomplete.</p>
    </template>

    <template v-else>

      <NominationForm v-if="theForm === 'nomination'" :credentials="credentials"/>
      <AcceptanceForm v-else-if="theForm === 'confirmation'" :credentials="credentials"/>

    </template>

  </div>


</template>

<script>

import NominationForm from "../components/RegisterAlternate/NominationForm.vue"
import AcceptanceForm from "../components/RegisterAlternate/AcceptanceForm.vue"


export default {
  name: "AlternateForm",
  components: {
    NominationForm,
    AcceptanceForm
  },
  data() {
    return {
      brokenPage: false,
      credentials: {},
      endpoints: {
        initiate: '/nominations/initiate',
        invite: '/nominations/invitation',
        inviteResult: '/nominations/result'
      }
    }
  },
  async mounted() {

    const params = new URLSearchParams(window.location.search),
        lcParams = {}

    for (const [k, v] of params) {
      lcParams[k.toLowerCase()] = v
    }

    const eventCodeDiv = document.querySelector('[data-event-code]')

    const ck = lcParams?.ck || null,
        id = lcParams?.id || null,
        eventCode = eventCodeDiv.dataset.eventCode || null


    // not valid
    if (!(ck && id && eventCode)) {
      this.brokenPage = true
      return
    }


    this.credentials = {ck, id, eventCode}

    // get delegate ID for acceptance form
    if (this.theForm === 'confirmation') {
      const delegateId = lcParams?.delid || null
      if (!delegateId) {
        this.brokenPage = true
        return
      }
      this.credentials.DELID = delegateId
    }

  },
  computed: {
    theForm() {
      const url = window.location.href
      if (/appoint-an-alternate/i.test(url)) {
        return 'nomination'
      }
      if (/alternate-confirmation/i.test(url)) {
        return 'confirmation'
      }
      return null
    }
  },
}
</script>

<style lang="scss">
@import "../components/RegisterAlternate/_alternate";
</style>